/**
 * View component for /transitions/new
 *
 * Creates a new transition from a copy of the defaultItem in the transition reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { history, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as nodeActions from '../../node/nodeActions';
import * as transitionActions from '../transitionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import transition components
import TransitionForm from '../components/TransitionForm.js.jsx';
import TransitionLayout from '../components/TransitionLayout.js.jsx';

class CreateTransition extends Base {
  constructor(props) {
    super(props);
    this.state = {
      transition: { ...this.props.defaultTransition }
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(nodeActions.fetchListIfNeeded());
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newTransitionState = _.update( this.state.transition, e.target.name, function() {
      return e.target.value;
    });
    this.setState({transition :newTransitionState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(transitionActions.sendCreateTransition(this.state.transition)).then((action) => {
      if(action.success) {
        dispatch(transitionActions.invalidateList());
        history.push(`/transitions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { transition } = this.state;
    const { nodeStore } = this.props;
    const isEmpty = (transition.name === null || transition.name === undefined);
    return (
      <TransitionLayout>
        <div className="flex">
          <section className="section">
            { isEmpty ?
                <h2> Loading...</h2>
              :
                <TransitionForm
                  cancelLink="/transitions"
                  formTitle="Create Transition"
                  formType="create"
                  handleFormChange={this._handleFormChange}
                  handleFormSubmit={this._handleFormSubmit}
                  nodeStore={nodeStore}
                  transition={transition}
                />
            }
          </section>
        </div>
      </TransitionLayout>
    )
  }
}

CreateTransition.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultTransition: store.transition.defaultItem
    , nodeStore: store.node
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateTransition)
);



// WEBPACK FOOTER //
// modules/transition/views/CreateTransition.js.jsx